import autoload from "./autoload";
import auth from './mixins/auth';
import cart from './mixins/cart';
import initDom from './mixins/init_dom';
import Container from "./components/site_pages/container.vue";

autoload();

window.app = new Vue({
  el: "#vue-site-pages",
  mixins: [initDom, auth, cart],

  components: {
    Container
  },
});

// displays the add-to-cart dropdown
require("./app_events");